export const PAGE_META = {
  home: {
    title: 'LSFP - Lotus Sports Fortune Protocol',
    description: '构建实体体育场景、澳门文旅与 Web3 数字权益融合的可持续增长生态。'
  },
  ecosystem: {
    title: '生态体系 - LSFP',
    description: '了解 LSFP 如何连接真实入口、会员沉淀、权益核销、商户收入与 LOTUS 价值引擎。'
  },
  partners: {
    title: '合作伙伴 - LSFP',
    description: '加入 LSFP 合作伙伴网络，共建下一代体育文旅会员经济。'
  },
  about: {
    title: '关于我们 - LSFP',
    description: '了解 Lotus Sports Fortune Protocol 的使命、愿景、核心价值观与长期生态优势。'
  },
  contact: {
    title: '联系我们 - LSFP',
    description: '联系 LSFP，获取商务合作、投资机构、媒体合作、技术支持与 Web3 生态合作支持。'
  }
}
